import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { newHireContactListRoute } from '@features/digitalOnboarding';
import { newHireContactList } from '@features/digitalOnboarding/constants';

type useGetNewHireConactsProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    companyId?: number;
};

export const useGetNewHireConacts = ({
    setErrorText = () => { },
    companyId
}: useGetNewHireConactsProps) => {
    const {
        data: newHireContact,
        isFetching: isLoadingData,
    } = useQuery({
        queryKey: [newHireContactList],
        queryFn: () => {
            return axiosInstance
                .get(
                    companyId !== undefined
                        ? `${newHireContactListRoute}?company_id=${companyId}`
                        : newHireContactListRoute) 
                .then((res) => res.data);
        },
        onSuccess: (data) => {
            if (data.object) {
                setErrorText('');
            }
            if (data.status !== 200) {
                setErrorText(data.message);
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });

    return {
        newHireContact,
        isLoadingData
    };
};
